import environment from "@/modules/environment";

export function getLocale() {
  const devLocale = (environment.isDev || environment.envMode === "test") && localStorage.getItem("dev-locale");
  const locale = devLocale || navigator.language.split("-")[0];
  log.app("locale", locale);
  return locale;
}
export function getlanguageCode() {
  const locale = navigator.language;
  return locale;
}
